//imports
import {
    DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL,
    DASHBOARD_PANEL_CREATE_REQUEST,
    DASHBOARD_PANEL_CREATE_RESULT,
    DASHBOARD_PANEL_EDIT_REQUEST,
    DASHBOARD_PANEL_EDIT_RESULT,
    DASHBOARD_PANEL_SEARCH_REQUEST,
    DASHBOARD_PANEL_SEARCH_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    result: null,
    panel: null,
    dashboard: []
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DASHBOARD_PANEL_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, panel: action.payload.data }

        case DASHBOARD_PANEL_CREATE_REQUEST:
            return { ...state, loading: true }

        case DASHBOARD_PANEL_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload.data }

        case DASHBOARD_PANEL_EDIT_REQUEST:
            return { ...state, loading: true }

        case DASHBOARD_PANEL_EDIT_RESULT:
            return { ...state, loading: false, update: action.payload.data }

        case DASHBOARD_PANEL_SEARCH_REQUEST:
            return { ...state, loading: true }

        case DASHBOARD_PANEL_SEARCH_RESULT:
            return { ...state, loading: false, dashboard: action.payload.data }

        case CLEAR_REDUX:
            return ["", "DASHBOARD_PANEL_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};